import React, { useCallback, useState } from 'react';
import LoadingSpinner from 'components/LoadingSpinner';
import LinkedRecordsTable from './LinkedRecordsTable';
import WorkOrderLinkedRecordDrawer from './WorkOrderLinkedRecordDrawer';
import { LinkedRecordsState } from './types';

interface LinkedRecordsTabProps {
  workOrderId: string;
  linkedRecords: LinkedRecordsState;
}

const LinkedRecordsTab = ({
  workOrderId,
  linkedRecords
}: LinkedRecordsTabProps) => {
  const [drawerRecordId, setDrawerRecordId] = useState<string | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleViewMore = useCallback((recordId: string) => {
    setDrawerRecordId(recordId);
    setIsDrawerOpen(true);
  }, []);

  const handleCloseDrawer = useCallback(() => {
    setIsDrawerOpen(false);
    setDrawerRecordId(null);
  }, []);

  if (linkedRecords.isLoading) {
    return (
      <div
        data-testid="linked-records-tab-loading"
        style={{ height: 'calc(100vh - 33em)' }}
        className="flex items-center justify-center"
      >
        <LoadingSpinner message="" className="h-full" />
      </div>
    );
  }

  if (linkedRecords.hasError) {
    return (
      <div
        data-testid="linked-records-tab-error"
        className="flex items-center justify-center py-8 text-neutral-50"
      >
        Unable to load linked records.
      </div>
    );
  }

  return (
    <div data-testid="linked-records-tab">
      <LinkedRecordsTable
        records={linkedRecords.records}
        totalRecords={linkedRecords.totalRecords}
        page={linkedRecords.page}
        onPageChange={linkedRecords.onPageChange}
        onViewMore={handleViewMore}
      />
      <WorkOrderLinkedRecordDrawer
        open={isDrawerOpen}
        recordId={drawerRecordId}
        workOrderId={workOrderId}
        onClose={handleCloseDrawer}
      />
    </div>
  );
};

export default LinkedRecordsTab;
